import src from "IMAGE";
export default { src, width: 1920, height: 547, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOUlEQVR42h2JsQkAMAgE3X8e93CDWEesLLRRSN7i4Lgjd5eIkKqS7l7gaHikqnzNODO5ZxY42vnvAYETOWKUWN4MAAAAAElFTkSuQmCC"};
